import { TrackerConfig } from '../../shared/config/tracker-config';

export const PROTOCOL_VERSION_CURRENT = 1;
export const DEFAULT_TRACKERS = [
  ...TrackerConfig.defaultWssTrackers,
];
export const PROTOCOL_LINK_PREFIX = 'https://share.app/v1/';
export const PROTOCOL_DEEP_LINK_PREFIX = 'share://v1/';
export const PROTOCOL_WEB_FALLBACK_PARAM = 'p';
